import { DragOverlay, useDndMonitor } from '@dnd-kit/core';
import { useState } from 'react';

import { NavNode } from '../../utils';
import { NavigationItem } from './NavigationItem';

interface Props {
  pinnedAndRecentPages: NavNode[];
}

export function DragOverlayContainer({ pinnedAndRecentPages }: Props) {
  const [activeNode, setActiveNode] = useState<NavNode | null>(null);

  useDndMonitor({
    onDragStart(event) {
      const active = pinnedAndRecentPages.find((page) => page.path === event.active.id);
      if (!active) return;
      setActiveNode(active);
    },
    onDragEnd() {
      setActiveNode(null);
    },
    onDragCancel() {
      setActiveNode(null);
    },
    onDragAbort() {
      setActiveNode(null);
    },
  });

  return (
    <DragOverlay>
      {activeNode ? (
        <div className="bg-mint-green rounded-md">
          <NavigationItem hideTooltip navNode={activeNode} />
        </div>
      ) : null}
    </DragOverlay>
  );
}
